// @ts-nocheck

import { createSelector } from 'reselect';

import {
  selectEntitiesBetslipsEntity,
  selectEntitiesBetslipsEntityBetAmount,
} from '../../../../selectors/entities/betslips/entitiesBetslipsPrimary.selector';
import { KLCollectibleLabelsByCollectibleId, KlComfortLabels } from '../../constants/labels';
import { KLComfortIds, KLRound3CollectibleIds } from '../../types/collectible';

const selectBetslipCollectibleId = createSelector(
  [selectEntitiesBetslipsEntity],
  (betslip) => betslip?.data?.KL?.id ?? betslip?.data?.KL?.type ?? null,
);

const selectKLHistoryBetslipEligibleCollectibleLabel = createSelector(
  [selectBetslipCollectibleId, selectEntitiesBetslipsEntityBetAmount],
  (collectibleId, betAmount) => {
    if (collectibleId) {
      const labels = KLCollectibleLabelsByCollectibleId[collectibleId];

      if (labels) {
        const { roundLabel, collectibleLabel } = labels;
        const isFromOrientation = KLRound3CollectibleIds.indexOf(collectibleId) !== -1;
        const isComfort = Object.keys(KLComfortIds).includes(collectibleId);

        let overrideCollectibleLabel = collectibleLabel;
        if (isFromOrientation) {
          overrideCollectibleLabel = null;
        }
        if (isComfort) {
          overrideCollectibleLabel = KLCollectibleLabelsByCollectibleId[collectibleId].collectibleType;
        }

        const comfortLabel =
          KlComfortLabels[collectibleId] && betAmount
            ? `${Math.min(betAmount, 50) * KlComfortLabels[collectibleId].coefficient}${
                KlComfortLabels[collectibleId].label
              }`
            : null;
        return [roundLabel, overrideCollectibleLabel, comfortLabel].filter((k) => k).join(' - ');
      }
    }
  },
);

const selectKLHistoryBetslipEligibleCollectibleProps = createSelector(
  [selectKLHistoryBetslipEligibleCollectibleLabel],
  (label) => ({
    label,
  }),
);

export default selectKLHistoryBetslipEligibleCollectibleProps;
